<!--
  Copyright (c) 2025-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<h2>Manage Component Lists</h2>
<label>{{ catalogListsBanner() || userMessage }}</label><br/>
<div class="mb-2 flex items-center">
</div>
<br />
<div class="px-3">
  <div class="text-center mb-2">
    <label class="mr-2">Component List:</label>
    <p-select
      [(ngModel)]="dropdownComponentListSelection"
      [options]="dropdownComponentListMap()"
      (onChange)="returnSearchResults()"
      placeholder="Select a component"
      optionLabel="label">
    </p-select>


    <br/>
    <br/>
    <strong>Component List used in:</strong>
  </div>
  <br/>

  <div class="text-center used-in-grid">
    @for (title of componentCatalogTitles(); track title) {
      <div class="used-in-grid-item">
        <label class="flex items-center">
          <input type="checkbox" disabled [checked]="isChecked(title)" class="mr-2"/>{{ title }}
        </label>
      </div>
    }
  </div>
</div>
<br/>
<div class="flex justify-center">
  <div class="flex w-full max-w-[600px] flex-col items-center">

    <ag-grid-angular style="width: 550px; height: 250px; margin-bottom: 1rem;" class="ag-theme-balham listCatalog"
      [undoRedoCellEditing]="true" [enableCellTextSelection]="true"
      [undoRedoCellEditingLimit]="50" [columnDefs]="columns" [rowData]="gridRowData()"
      [rowHeight]="25" [pagination]="false" (cellValueChanged)="onCellValueChanged($event)">
    </ag-grid-angular>
    <div class="flex flex-row items-center" id="addListItemDiv"
      ng-model="addListItemDiv" ng-show="addItem">
      @if (!isAdding && dropdownComponentListSelection?.value) {
        <button class="pull-left btn btn-outline-primary"
          style=" margin-top: 5px; height: 35px;" (click)="onToggleIsAdding()">
          <b>Add Item <span class="fa fa-chevron-right"></span></b>
        </button>
      }
      @if (isAdding && dropdownComponentListSelection?.value) {
        <div>
          <button class="pull-left btn btn-outline-primary"
            style=" margin-top: 5px; height: 35px;" (click)="onToggleIsAdding()">
            <b>Cancel <span class="fa fa-chevron-left"></span></b>
          </button>
          <input class="pull-left" style="margin-top: 5px; height: 35px;"
            placeholder="New List Item Name" maxlength="maxNameLength"
            [(ngModel)]="newItem" (ngModelChange)="validateNewItem()">
            <button class="pull-left btn btn-outline-primary"
              [disabled]="newItemValidationMessage || !newItem"
              style="margin-top: 4px;" (click)="createNewListItem()">
              Upload
            </button>
          </div>
        }
      </div>
      <div>{{newItemValidationMessage}}</div>
    </div>
  </div>

